import { Typography } from "@mui/material";
import FormReservation from "./FormReservation";
import ModalBox from "../../ui/ModalBox";
import { useReservation } from "./provider";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const UpdateReservation = () => {
  const {
    state: { selected: reservationInfo },
    fetchOne,
  } = useReservation();
  //state which check open or close modal
  const [open, setOpen] = useState(false);
  const [reload, setReload] = useState(false);
  const { id } = useParams();
  //var to navigate another page

  const navigate = useNavigate();
  //close modal function
  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  //open modal function when  clicked button

  const handleSuccess = () => {
    setOpen(true);
    setReload(!reload);
  };
  useEffect(() => {
    fetchOne(id);
  }, [fetchOne, id, reload]);

  if (!reservationInfo) return;
  if (reservationInfo?.id != id) return;

  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Update Reservation
      </Typography>
      <FormReservation
        handleSuccess={handleSuccess}
        reservation={reservationInfo}
      />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The update operation has been completed successfully.."
        name="Reservation"
      />
    </>
  );
};

export default UpdateReservation;
